"use client";

import React from "react";
import { CircleCheck as CheckCircle, ShieldCheck, ArrowRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SpecialistPelvicHealthPhysiotherapist() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="specialist-pelvic-health-physiotherapist" ref={sectionRef} className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full max-w-md mx-auto lg:max-w-none transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden shadow-strong">
              <img src="https://alignphysiotherapy.co.uk/wp-content/uploads/2026/03/Pelvic-Health-Website-Picture-1.jpeg" alt="Specialist Pelvic Health Physiotherapist" className="w-full h-full object-cover object-center" />
              {}
              <div className="absolute inset-0 bg-muted/30 mix-blend-multiply pointer-events-none"></div>
              
              {}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-accent/10 rounded-full blur-2xl pointer-events-none"></div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/10 rounded-full blur-2xl pointer-events-none"></div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col items-start transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <Badge className="mb-6 px-4 py-1.5 text-sm rounded-full bg-primary text-primary-foreground flex items-center gap-2 shadow-soft">
              <ShieldCheck className="size-4" />
              Verified Expert
            </Badge>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4 leading-tight">
              Specialist Pelvic Health Physiotherapist
            </h2>

            {}
            <h3 className="text-xl md:text-2xl font-display font-semibold text-primary mb-6">
              Evidence-Based Specialist Care
            </h3>

            <p className="text-base md:text-lg text-muted-foreground mb-6 leading-relaxed">Providing comprehensive, discreet, and highly specialised assessment and treatment for a wide range of pelvic floor dysfunctions. Our approach is rooted in the latest clinical research, ensuring you receive the most effective care tailored to your specific needs.</p>

            <ul className="space-y-3 mb-8 w-full">
              {["Evidence-based physiotherapy", "Personalised rehabilitation programmes", "Private and comfortable clinic environment", "Experienced physiotherapy team", "Focus on long-term recovery and confidence."].map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-foreground">
                  <CheckCircle className="size-5 text-accent shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>)}
            </ul>

            {}
            <div className="w-full max-w-md flex items-center gap-4 p-4 rounded-xl border border-border bg-secondary/30 mb-8 shadow-soft">
              <div className="shrink-0 bg-background p-2.5 rounded-lg shadow-sm border border-border/50">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/pogp_logo_verified.png" alt="POGP Logo" className="h-10 w-auto object-contain" />
              </div>
              <div>
                <p className="text-sm font-bold text-foreground font-display">POGP Affiliated&nbsp;</p>
                <p className="text-xs text-muted-foreground leading-tight mt-0.5">
                  Pelvic, Obstetric and Gynaecological Physiotherapy
                </p>
              </div>
            </div>

            <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
              <Button size="lg" className="group">
                Book a Consultation
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>

        </div>
      </div>
    </section>;
}